import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { from, Observable, of } from 'rxjs';
import { map, catchError, mergeMap, switchMap } from 'rxjs/operators';

import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';

import { InvestmentAssetIntangibleService } from '../../services/investment-asset-intangible.service';
import { DeleteInvestmentAssetIntangible, DeleteInvestmentAssetIntangibleFailure, DeleteInvestmentAssetIntangibleSuccess, InvestmentAssetIntangibleActionTypes, LoadInvestmentAssetIntangible, LoadInvestmentAssetIntangibleFailure, LoadInvestmentAssetIntangibles, LoadInvestmentAssetIntangiblesFailure, LoadInvestmentAssetIntangiblesSuccess, LoadInvestmentAssetIntangibleSuccess, UpdateInvestmentAssetIntangible, UpdateInvestmentAssetIntangibleFailure, UpdateInvestmentAssetIntangibleSuccess } from '../actions/investment-asset-intangible.actions';
import { SummaryInvestmentAssetIntangibleModel } from '../../models/summary-investment-asset-intangible.model';


@Injectable()
export class InvestmentAssetIntangibleEffects {
  constructor(
    private actions$: Actions,
    private service: InvestmentAssetIntangibleService
  ) { }

  /** 🔹 Get All */

  
  loadInvestmentAssetIntangibles$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(InvestmentAssetIntangibleActionTypes.LoadInvestmentAssetIntangibles),
    mergeMap((action: LoadInvestmentAssetIntangibles) =>
      this.service.getBySearch(action.payload.filter).pipe(
        map((res: PaginableResponseModel<SummaryInvestmentAssetIntangibleModel>) => {
          if (!res || !res.isSuccess) {
              return new LoadInvestmentAssetIntangiblesFailure({ error: 'No se pudo cargar la lista' });
            }
            return new LoadInvestmentAssetIntangiblesSuccess({
              items: res.values,
              total: res.total
            });
          }),
          catchError(error => of(new LoadInvestmentAssetIntangiblesFailure({ error })))
        )
      )
    ));


      /** 🔹 Get By Id */
      
      loadInvestmentAssetIntangibleById$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(InvestmentAssetIntangibleActionTypes.LoadInvestmentAssetIntangible),
        mergeMap((action: LoadInvestmentAssetIntangible) =>
          this.service.getById(action.payload.uid).pipe(
            map(response => new LoadInvestmentAssetIntangibleSuccess(response)),
            catchError(error => of(new LoadInvestmentAssetIntangibleFailure({ error })))
          )
        )
      ));

       /** 🔹 Update */
        
        updateInvestmentAssetIntangible$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(InvestmentAssetIntangibleActionTypes.UpdateInvestmentAssetIntangible),
          mergeMap((action: UpdateInvestmentAssetIntangible) =>
            this.service.update(action.payload.investmentAsset).pipe(
              switchMap(updated => [
                new UpdateInvestmentAssetIntangibleSuccess({ investmentAsset: updated }),
              ]),
              catchError(error => of(new UpdateInvestmentAssetIntangibleFailure({ error })))
            )
          )
        ));

        /** 🔹 Delete */
        
        deleteInvestmentAssetIntangible$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(InvestmentAssetIntangibleActionTypes.DeleteInvestmentAssetIntangible),
          mergeMap((action: DeleteInvestmentAssetIntangible) =>
            this.service.delete(action.payload.uid).pipe(
              switchMap(() => [
                new DeleteInvestmentAssetIntangibleSuccess({ uid: action.payload.uid }),
              ]),
              catchError(error => of(new DeleteInvestmentAssetIntangibleFailure({ error })))
            )
          )
        ));



}
